import React, {useState, useEffect} from 'react';

export const PreguntaEncuesta = (props) => {
	const {id, titlo, numeroMaximo, obligatoria, contestarPregunta} = props;

	const [OpcionSeleccionada, setOpcionSeleccionada] = useState(
		// rellenamos el array con el numero de opciones
		[...Array(numeroMaximo)].map((e, i) => {
			return 'valorSeleccion';
		})
	);

	useEffect(() => {}, []);

	const seleccionarOpcion = (val) => {
		// Actualizamos el estado de la respuesta dada por el cliente
		contestarPregunta(id, val);

		// Actualizamos el estado de la clase de la opciones
		let listaAxu = OpcionSeleccionada;
		listaAxu.map((opcion, i) => {
			if (i === val - 1 && listaAxu[i] === 'valorSeleccion') {
				listaAxu[i] = 'valorSeleccionActive';
			} else {
				listaAxu[i] = 'valorSeleccion';
			}
		});
		setOpcionSeleccionada(listaAxu);
	};

	return (
		<div className='preguntaEncuesta'>
			<div className='tituloPregunta'>
				<div className='centrador'>{titlo}</div>
				{obligatoria && (
					<div className='obligatorioPregunta centrador'>
						<svg
							xmlns='http://www.w3.org/2000/svg'
							width='10'
							height='10'
							fill='currentColor'
							className='bi bi-asterisk'
							viewBox='0 0 16 16'
						>
							<path d='M8 0a1 1 0 0 1 1 1v5.268l4.562-2.634a1 1 0 1 1 1 1.732L10 8l4.562 2.634a1 1 0 1 1-1 1.732L9 9.732V15a1 1 0 1 1-2 0V9.732l-4.562 2.634a1 1 0 1 1-1-1.732L6 8 1.438 5.366a1 1 0 0 1 1-1.732L7 6.268V1a1 1 0 0 1 1-1z' />
						</svg>
					</div>
				)}
			</div>
			<div className='separador'></div>
			<div className='opcionesPregunta'>
				{[...Array(numeroMaximo)].map((e, i) => (
					<div
						className={OpcionSeleccionada[i]}
						key={i}
						onClick={() => seleccionarOpcion(i + 1)}
					>
						{i + 1}
					</div>
				))}
			</div>
		</div>
	);
};
